module.exports = __webpack_public_path__ + "static/potion-of-healing-mtg_afr-2c346a470cb8845b7f296846d18e9a20.jpg";